import {UIIcon} from '@dropbox/dig-icons';
import {AvatarIcon} from 'components/DSYS/Avatar';
import type {ComponentType, SVGAttributes} from 'react';

/**
 * A search result's left icon. `tiled` (the Ask relaunch) puts it in an
 * avatar-sized tile, so teams, workstreams and articles line up with the people
 * and Ask rows around them; otherwise it's the bare glyph.
 */
export const ResultIcon = ({
  src,
  tiled,
}: {
  src: ComponentType<SVGAttributes<SVGElement>>;
  tiled: boolean;
}) =>
  tiled ? (
    // DIG's line icons are drawn at 24px; at the tile's own size they blur.
    <AvatarIcon src={src} size="large" iconSize="standard" />
  ) : (
    <UIIcon
      style={{marginLeft: '5px', marginRight: '5px'}}
      color="var(--dig-color__text__subtle)"
      src={src}
      size="large"
    />
  );
